import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.sentry.enabled && environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: `simskills-dashboard@${environment.name}`,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [environment.apiUrl],
      }),
    ],
    tracesSampleRate: environment.sentry.tracesSampleRate,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
